var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisableSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 0.703125C18.2289 0.703125 23.2969 5.77083 23.2969 12C23.2969 18.229 18.2288 23.2967 11.9999 23.2967C5.77087 23.2967 0.703125 18.2289 0.703125 12C0.703125 5.77092 5.77083 0.703125 11.9999 0.703125ZM10.5063 14.0866L7.96917 11.5501C7.7205 11.3015 7.3177 11.3015 7.06908 11.5501C6.82083 11.7983 6.82092 12.2016 7.06908 12.4498L10.0567 15.4374C10.3045 15.6853 10.7084 15.6853 10.9562 15.4374L16.9302 9.4628C17.1788 9.21412 17.1788 8.8117 16.9302 8.56303C16.6816 8.31445 16.2791 8.3145 16.0305 8.56303L10.5063 14.0866Z",
    fill: "#537C5B",
    fillOpacity: 0.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableSuccess);
export default __webpack_public_path__ + "static/media/disableSuccess.45b39c95f829ca31793b6c69b3d04af5.svg";
export { ForwardRef as ReactComponent };